import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaEdit, FaMinus, FaPlus, FaTrash} from "react-icons/fa";

class ListOrderAllComponent extends Component {

    listInfoOrder = () => {
        return (
            this.props.order.order_info.map( (order_info, key) => (
                <div key={key}>
                    { order_info.value }
                </div>
            ))
        )
    }

    loadStatus = () => {
        if ( this.props.order.status === 'Pending' ) {
            return (
                <span className="text-danger">Chưa thanh toán</span>
            )
        }
        else if ( this.props.order.status === 'Finish' ) {
            return (
                <span className="text-success">Đã thanh toán</span>
            )
        }
        else if ( this.props.order.status === 'Waiting' ) {
            return (
                <span className="text-info">Thanh toán chờ</span>
            )
        }
        else {
            return (
                <span className="text-danger">Hủy</span>
            )
        }
    }

    render() {
        return (
            <tr>
                <td>{ this.props.order.ma_gd }</td>
                <td>
                    { this.props.order.text_type_order }
                    <button type="button" className="btn btn-sm btn-outline-gray float-right" onClick={ () => this.props.loadInfo( this.props.actionKey ) }>
                        {
                            this.props.order.showInfo === 'show' ? (
                                <FaMinus />
                            ) : (
                                <FaPlus />
                            )
                        }
                    </button>
                    <div className={"text-left mt-2 collapse " + this.props.order.showInfo}>
                        { this.listInfoOrder() }
                    </div>
                </td>
                <td>{ this.props.order.text_date_create }</td>
                <td>{ this.props.order.text_total }</td>
                <td>{ this.loadStatus() }</td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Thông tin đơn hàng
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Link to={"/don-dat-hang/" + this.props.order.id + '/chi-tiet-don-dat-hang.html'} className="btn btn-warning btn-sm mr-1 text-light">
                            <FaEdit />
                        </Link>
                    </OverlayTrigger>
                    {
                        this.props.order.status === 'Pending' || this.props.order.status === 'Waiting' ? (
                            <OverlayTrigger
                                delay={{ hide: 450, show: 300 }}
                                overlay={(props) => (
                                    <Tooltip {...props}>
                                        Hủy đơn hàng
                                    </Tooltip>
                                )}
                                placement="top"
                            >
                                <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.actionKey, 'deleteOrder' ) }>
                                    <FaTrash />
                                </button>
                            </OverlayTrigger>
                        ) : (
                            <></>
                        )
                    }
                </td>
            </tr>
        );
    }
}

export default ListOrderAllComponent;